/**
 * ResumeStats — computed aggregate statistics for a runner's resume.
 *
 * Never stored directly; always derived from race data at read-time.
 * Pure domain model, no Firebase dependencies.
 */
export class ResumeStats {
  constructor({
    totalDistance = 0,
    totalElevation = 0,
    avgPace = null,
    raceCount = 0,
    prByDistance = new Map(),
    highlightedCount = 0,
  } = {}) {
    this.totalDistance = totalDistance; // km
    this.totalElevation = totalElevation; // metres
    this.avgPace = avgPace; // seconds per km, or null
    this.raceCount = raceCount;
    this.prByDistance = prByDistance; // Map<category, { raceName, time, distance }>
    this.highlightedCount = highlightedCount;
  }

  // ---------------------------------------------------------------------------
  // Formatted getters
  // ---------------------------------------------------------------------------

  /** e.g. "2,482" */
  get formattedTotalDistance() {
    return Math.round(this.totalDistance).toLocaleString('en-US');
  }

  /** e.g. "4'12\"" — null when no average pace exists */
  get formattedAvgPace() {
    if (this.avgPace == null) return null;
    const mins = Math.floor(this.avgPace / 60);
    const secs = Math.round(this.avgPace % 60);
    return `${mins}'${String(secs).padStart(2, '0')}"`;
  }
}
